class UserPayee {
  public readonly id: string;
  public readonly paymentUserId: string;
  public readonly lastName: string;
  public readonly firstName: string;
  public readonly agentName: string;
  public readonly agentRepresentativeName: string;
  public readonly countryOfResidence: string;
  public readonly nationality: string;
  public readonly optional: string;
  public readonly streetAddress: string;
  public readonly cityName: string;
  public readonly province: string;
  public readonly postalCode: string;
  public readonly phoneNumber: string;
  constructor({
    id,
    paymentUserId,
    lastName,
    firstName,
    agentName,
    agentRepresentativeName,
    countryOfResidence,
    nationality,
    optional,
    streetAddress,
    cityName,
    province,
    postalCode,
    phoneNumber,
  }: {
    id: string;
    paymentUserId: string;
    lastName: string;
    firstName: string;
    agentName: string;
    agentRepresentativeName: string;
    countryOfResidence: string;
    nationality: string;
    optional: string;
    streetAddress: string;
    cityName: string;
    province: string;
    postalCode: string;
    phoneNumber: string;
  }) {
    this.id = id;
    this.paymentUserId = paymentUserId;
    this.lastName = lastName;
    this.firstName = firstName;
    this.agentName = agentName;
    this.agentRepresentativeName = agentRepresentativeName;
    this.countryOfResidence = countryOfResidence;
    this.nationality = nationality;
    this.optional = optional;
    this.streetAddress = streetAddress;
    this.cityName = cityName;
    this.province = province;
    this.postalCode = postalCode;
    this.phoneNumber = phoneNumber;
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      payment_user_id,
      last_name,
      first_name,
      agent_name,
      agent_representative_name,
      country_of_residence,
      nationality,
      optional,
      street_address,
      city_name,
      province,
      postal_code,
      phone_number,
    } = Object.assign({}, value);

    if (typeof id !== 'number') throw new TypeError('.id must be a number');
    if (typeof payment_user_id !== 'number') throw new TypeError('.payment_user_id must be a number');
    if (typeof country_of_residence !== 'string') throw new TypeError('.country_of_residence must be a string');
    // if (typeof nationality !== 'string') throw new TypeError('.nationality must be a string');//agent対応
    if (typeof street_address !== 'string') throw new TypeError('.street_address must be a string');
    if (typeof city_name !== 'string') throw new TypeError('.city_name must be a string');
    if (typeof province !== 'string') throw new TypeError('.province must be a string');
    if (typeof postal_code !== 'string') throw new TypeError('.postal_code must be a string');

    return new UserPayee({
      id: String(id),
      paymentUserId: String(payment_user_id),
      lastName: last_name || '',
      firstName: first_name || '',
      agentName: agent_name || '',
      agentRepresentativeName: agent_representative_name || '',
      countryOfResidence: country_of_residence,
      nationality: nationality || '',
      optional: optional || '',
      streetAddress: street_address,
      cityName: city_name,
      province,
      postalCode: postal_code,
      phoneNumber: phone_number || '',
    });
  };
}

export default UserPayee;
